module.exports = __webpack_public_path__ + "static/media/Logo.bb14b868.svg";